var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllchainColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29967 9.99981C8.17076 10.0068 8.04242 9.97809 7.92883 9.91673C7.81524 9.85537 7.72083 9.76379 7.65605 9.65212C7.59126 9.54046 7.55862 9.41304 7.56173 9.28398C7.56484 9.15492 7.60358 9.02922 7.67367 8.92081L11.3997 2.99981C11.4582 2.89437 11.543 2.80586 11.6458 2.74284C11.7487 2.67981 11.866 2.64442 11.9865 2.6401C12.1071 2.63577 12.2266 2.66266 12.3337 2.71815C12.4408 2.77363 12.5317 2.85584 12.5977 2.95681L16.2997 8.89981C16.3726 9.0046 16.4156 9.12735 16.4238 9.25478C16.432 9.38221 16.4052 9.50946 16.3463 9.62276C16.2874 9.73605 16.1986 9.83107 16.0895 9.89753C15.9805 9.96399 15.8554 9.99936 15.7277 9.99981H8.29967Z",
    fill: "#E34F8D",
    stroke: "#E34F8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H4C3.44772 14 3 14.4477 3 15V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V15C10 14.4477 9.55228 14 9 14Z",
    fill: "#E42575",
    stroke: "#E42575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21C19.433 21 21 19.433 21 17.5C21 15.567 19.433 14 17.5 14C15.567 14 14 15.567 14 17.5C14 19.433 15.567 21 17.5 21Z",
    fill: "#CA1661",
    stroke: "#CA1661",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllchainColor);
export default __webpack_public_path__ + "static/media/allchainColor.083ab6e8eb95418c333e24dff11a02ec.svg";
export { ForwardRef as ReactComponent };